import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import CadastroContainer from "../../../../components/CadastroContainer/CadastroContainer";
import FormGroups from "../FormGroups/FormGroups";
import "./CadastroGroups.css";
import GroupService from "../../../../services/GroupsService";

const CadastroGroups = () => {
	const { groupId } = useParams();
	const { state } = useLocation();
	const [group, setGroup] = useState();
	const [type, setType] = useState("");

	async function loadGroup(id) {
		const response = await GroupService.getGroup(id);
		if (response.data) {
			setGroup(response.data);
		}
	}

	useEffect(() => {
		setType(groupId || state ? "edicao" : "cadastro");

		if (group) {
			setGroup(state);
			return;
		}

		if (groupId) {
			loadGroup(groupId);
		}
	}, [state, groupId]);

	return (
		<CadastroContainer>
			<FormGroups group={group} type={type} />
		</CadastroContainer>
	);
};

export default CadastroGroups;
